<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card p-3">
      <div class="card-body">
        <h2 class="card-title-desc">Add New Customer</h2>
        <customer-form button_text="Add Customer" @customerAction="customerAction"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import CustomerForm from "@/components/customers/customer-form";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {routeItems} from "@/router/endpoints";

export default {
  page: {
    title: "Add Customers",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {CustomerForm, PageHeader, Layout},
name: "add-customers",
  data() {
    return {
      title: "Add Customers",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Add Customers",
          active: true
        }
      ],
    }
  },
  methods: {
    ... mapActions({
      addCustomer: 'customers/addNewCustomer',
    }),
    async customerAction(data){
      await this.addCustomer(data).then(resp => {
        if(resp.publicId){
          successToast('New customer added successfully')
          this.$router.push(routeItems.single_customer_route+'/'+resp.publicId)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
